import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=a96b1298&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=a96b1298&prod&lang=css"
import style1 from "./Index.vue?vue&type=style&index=1&id=a96b1298&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96b1298",
  null
  
)

export default component.exports